// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Combinators = require("../Data.Argonaut.Encode.Combinators/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Show = require("../Data.Show/index.js");
var Floor = (function () {
    function Floor() {

    };
    Floor.value = new Floor();
    return Floor;
})();
var Wall = (function () {
    function Wall() {

    };
    Wall.value = new Wall();
    return Wall;
})();
var StairsUp = (function () {
    function StairsUp() {

    };
    StairsUp.value = new StairsUp();
    return StairsUp;
})();
var StairsDown = (function () {
    function StairsDown() {

    };
    StairsDown.value = new StairsDown();
    return StairsDown;
})();
var showTile = new Data_Show.Show(function (v) {
    if (v instanceof Floor) {
        return "F";
    };
    if (v instanceof Wall) {
        return "W";
    };
    if (v instanceof StairsUp) {
        return "<";
    };
    if (v instanceof StairsDown) {
        return "<";
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Tile (line 35, column 10 - line 39, column 22): " + [ v.constructor.name ]);
});
var seeableThrough = function (v) {
    if (v instanceof Floor) {
        return true;
    };
    if (v instanceof Wall) {
        return false;
    };
    if (v instanceof StairsDown) {
        return true;
    };
    if (v instanceof StairsUp) {
        return true;
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Tile (line 28, column 18 - line 32, column 19): " + [ v.constructor.name ]);
};
var passibleThrough = function (v) {
    if (v instanceof Floor) {
        return true;
    };
    if (v instanceof Wall) {
        return false;
    };
    if (v instanceof StairsDown) {
        return true;
    };
    if (v instanceof StairsUp) {
        return true;
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Tile (line 21, column 19 - line 25, column 19): " + [ v.constructor.name ]);
};
var encodeJsonTile = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    if (v instanceof Floor) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("tile")("Floor"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof Wall) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("tile")("Wall"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof StairsDown) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("tile")("StairsDown"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof StairsUp) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("tile")("StairsUp"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Tile (line 53, column 16 - line 65, column 27): " + [ v.constructor.name ]);
});
var decodeJsonTile = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (v) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(v)("tile"))(function (v1) {
            if (v1 === "Wall") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(Wall.value);
            };
            if (v1 === "Floor") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(Floor.value);
            };
            if (v1 === "StairsDown") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(StairsDown.value);
            };
            if (v1 === "StairsUp") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(StairsUp.value);
            };
            return new Data_Either.Left("Unknown Tile " + v1);
        });
    });
});
module.exports = {
    Floor: Floor,
    Wall: Wall,
    StairsUp: StairsUp,
    StairsDown: StairsDown,
    passibleThrough: passibleThrough,
    seeableThrough: seeableThrough,
    showTile: showTile,
    decodeJsonTile: decodeJsonTile,
    encodeJsonTile: encodeJsonTile
};
